<div *ngIf="isMobile">
  <app-quote-details-mobile [quoteSummary]="quoteSummary" (updated)="quoteUpdated($event)"></app-quote-details-mobile>
</div>
<div *ngIf="!isMobile">
  <!--<app-quote-details-desktop></app-quote-details-desktop>-->
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-9 quote-section">
        <div class="quote-header">
          <span i18n>Change Order:</span> {{changeOrder.changeOrder_Name}}
          <button *ngIf="!readOnly" class="ml-3 btn btn-bidit-edit" (click)="openEditDialog()" title="Edit title"></button>
          <div class="form-inline float-right" *ngIf="this.changeOrderAcknowlegement?.acknowledgementStatusDesc">
            <div class="mr-3"><span class="col-form-label" i18n>Acknowledgement Status: </span> {{this.changeOrderAcknowlegement?.acknowledgementStatusDesc}}</div>
            <div *ngIf="this.changeOrderAcknowlegement?.acknowledgedDate">
              <span class="col-form-label" i18n>Acknowledgement Date: </span><span class="mr-5"> {{this.changeOrderAcknowlegement?.acceptedQuoteRejectedDate ?? this.changeOrderAcknowlegement?.acknowledgedDate | date:'MM/dd/yyyy'}}</span>
            </div>
          </div>
        </div>
        <div class="quote-header">
          <span i18n>Comments:</span> {{changeOrder.changeOrder_Comments}}
        </div>
        <div *ngIf="!readOnly" class="p-2">
          <span i18n>Add product items to your quote.</span>
          <button class="ml-2 btn btn-bidit-navigate" (click)="openAreaDialog(null)" i18n>Add Product Item</button>
        </div>

        <div *ngFor="let area of areaSummaries">
          <h5 class="mb-0">
            {{area.area_Name}}
          </h5>
          <table class="table table-quote-area">
            <thead>
              <tr>
                <th></th>
                <th i18n>Sub Area</th>
                <th i18n>R-Value</th>
                <th i18n>Product</th>
                <th i18n>Sqr Ftg</th>
                <ng-container *ngIf="area.area_IsOption; then optionsHeader; else defaultHeader"></ng-container>
                <ng-template #optionsHeader>
                  <th i18n>Estimate Change</th>
                  <th i18n>Cost Change</th>
                </ng-template>
                <ng-template #defaultHeader>
                  <th i18n>Addl Items</th>
                  <th i18n>Cost</th>
                </ng-template>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor let-quoteArea [ngForOf]="area.quoteAreas">
                <tr *ngIf="quoteArea.acceptedItem" class="border-bottom" [ngClass]="{ 'change-row': quoteArea.changeOrderItem}">
                  <td>
                    <ng-container *ngIf="quoteArea.changeOrderItem; then changedStatus; else unmodifiedStatus"></ng-container>
                    <ng-template #changedStatus i18n>Original</ng-template>
                    <ng-template #unmodifiedStatus i18n>Unmodified</ng-template>
                  </td>
                  <td>
                    <p *ngIf="quoteArea.acceptedItem.subArea">
                      {{quoteArea.acceptedItem.subArea.subArea_Name}}
                      <span *ngIf="quoteArea.quoteItem.area_Name">- ({{quoteArea.quoteItem.area_Name}})</span>
                    </p>
                  </td>
                  <td>
                    <p *ngIf="quoteArea.acceptedItem.itemUsage; then usageBlock; else rValueBlock"></p>
                    <ng-template #usageBlock>{{quoteArea.acceptedItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                    <ng-template #rValueBlock>
                      <span *ngIf="quoteArea.acceptedItem.item?.rValue">
                        {{quoteArea.acceptedItem.item.rValue.rValue_Desc}}
                      </span>
                    </ng-template>
                  </td>
                  <td>
                    <span *ngIf="quoteArea.acceptedItem.item">
                      <span *ngIf="quoteArea.acceptedItem.item.item_Part">{{quoteArea.acceptedItem.item.item_Part}},</span>
                      {{quoteArea.acceptedItem.item.item_Name}}
                    </span>
                    <span *ngIf="!quoteArea.acceptedItem.item">
                      {{quoteArea.acceptedItem.area_Note}}
                    </span>
                  </td>
                  <td>
                    {{quoteArea.acceptedItem.area_SqrFtg | number: '1.2' }}
                  </td>
                  <td>
                    <div *ngIf="area.area_IsOption; else defaultAccessories">
                      <div *ngIf="showLinePricing">
                        ${{quoteArea.acceptedItem.optionBid | number: '1.2' }}
                      </div>
                    </div>
                    <ng-template #defaultAccessories>
                      {{quoteArea.acceptedItem.accessories.length}}
                    </ng-template>
                  </td>
                  <td *ngIf="showLinePricing">
                    <span>${{quoteArea.acceptedItem.area_TotalCost | number: '1.2' }}</span>
                  </td>
                  <td>
                    <div *ngIf="!this.readOnly">
                      <div *ngIf="quoteArea.changeOrderItem; else unmodifiedButtons">
                      </div>
                      <ng-template #unmodifiedButtons>
                        <button *ngIf="area.area_IsOption==false" class="mb-1 mr-1 btn btn-bidit-navigate" (click)="openAreaDialog(quoteArea, quoteArea.changeOrderItem)" title="Change Item" i18n>Change Item</button>
                        <button class="mb-1 btn btn-bidit-navigate" (click)="deleteArea(quoteArea.acceptedItem)" title="Cancel Item" i18n>Cancel Item</button>
                      </ng-template>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="quoteArea.changeOrderItem" class="border-bottom change-row">
                  <td i18n>Revised</td>
                  <td>
                    <p *ngIf="quoteArea.changeOrderItem.subArea">
                      {{quoteArea.changeOrderItem.subArea.subArea_Name}}
                      <span *ngIf="quoteArea.changeOrderItem.changeOrderItem_Name">- ({{quoteArea.changeOrderItem.changeOrderItem_Name}})</span>
                    </p>
                  </td>
                  <td>
                    <div *ngIf="quoteArea.changeOrderItem.item">
                      <p *ngIf="quoteArea.changeOrderItem.itemUsage; then usageBlock; else rValueBlock"></p>
                      <ng-template #usageBlock>{{quoteArea.changeOrderItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                      <ng-template #rValueBlock>
                        <span *ngIf="quoteArea.changeOrderItem.item?.rValue">
                          {{quoteArea.changeOrderItem.item?.rValue.rValue_Desc}}
                        </span>
                      </ng-template>
                    </div>
                  </td>
                  <td>
                    <div *ngIf="quoteArea.changeOrderItem.changeOrderItem_IsDelete; else modifiedBlock" i18n>REMOVED</div>
                    <ng-template #modifiedBlock>
                      <span *ngIf="quoteArea.changeOrderItem.item">
                        <span *ngIf="quoteArea.changeOrderItem.item.item_Part">{{quoteArea.changeOrderItem.item.item_Part}},</span>
                        {{quoteArea.changeOrderItem.item.item_Name}}
                      </span>
                      <span *ngIf="!quoteArea.changeOrderItem.item">
                        {{quoteArea.changeOrderItem.changeOrderItem_Note}}
                      </span>
                    </ng-template>
                  </td>
                  <td>
                    {{quoteArea.acceptedItem.area_SqrFtg + quoteArea.changeOrderItem.changeOrderItem_SqrFtgAdjustment | number: '1.2' }}
                  </td>
                  <td>
                    <div *ngIf="area.area_IsOption; else defaultAccessories">
                      <div *ngIf="showLinePricing">
                        ${{quoteArea.changeOrderItem.optionBid | number: '1.2' }}
                      </div>
                    </div>
                    <ng-template #defaultAccessories>
                      {{quoteArea.changeOrderItem.accessories.length}}
                    </ng-template>
                  </td>
                  <td *ngIf="showLinePricing">
                    <span>${{quoteArea.acceptedItem.area_TotalCost + quoteArea.changeOrderItem.changeOrderItem_TotalCost | number: '1.2' }}</span>
                  </td>
                  <td>
                  </td>
                </tr>
                <tr *ngIf="quoteArea.changeOrderItem" class="alert border-bottom change-row">
                  <td i18n>Net</td>
                  <td>
                  </td>
                  <td>
                  </td>
                  <td>
                  </td>
                  <td>
                    {{quoteArea.changeOrderItem.changeOrderItem_SqrFtgAdjustment | number: '1.2' }}
                  </td>
                  <td>
                  </td>
                  <td *ngIf="showLinePricing">
                    <span>${{quoteArea.changeOrderItem.changeOrderItem_TotalCost | number: '1.2' }}</span>
                  </td>
                  <td>
                    <div *ngIf="!this.readOnly">
                      <div *ngIf="quoteArea.changeOrderItem; else unmodifiedButtons">
                        <button class="btn btn-bidit-navigate" (click)="revertChangeOrder(quoteArea.changeOrderItem.changeOrderItem_ID)" title="Revert Change" i18n>Undo Change</button>
                        <button class="ml-1 btn btn-bidit-edit" (click)="openAreaDialog(quoteArea, quoteArea.changeOrderItem.changeOrderItem_ID)" title="Edit"></button>
                      </div>
                      <ng-template #unmodifiedButtons>
                        <button class="btn btn-bidit-edit" (click)="openAreaDialog(quoteArea, null)" title="Edit product" i18n-title></button>
                        <button class="btn btn-bidit-delete" (click)="deleteArea(quoteArea.acceptedItem)" title="Remove product" i18n-title></button>
                      </ng-template>
                    </div>
                  </td>
                </tr>

                <tr *ngFor="let workOrder of quoteArea.workOrders">
                  <td colspan="5"><span i18n>WORK ORDER</span> - #{{workOrder.workOrder_Seq}} - {{workOrder.workOrder_Start | date: 'M/d/yyyy'}} - {{workOrder.workOrder_Stop | date: 'M/d/yyyy'}}</td>
                </tr>
              </ng-template>
              <ng-template ngFor let-newItem [ngForOf]="area.newItems">
                <tr class="alert change-row">
                  <td i18n>New</td>
                  <td>
                    <p *ngIf="newItem.subArea">
                      {{newItem.subArea.subArea_Name}}
                      <span *ngIf="newItem.changeOrderItem_Name">- ({{newItem.changeOrderItem_Name}})</span>
                    </p>
                  </td>
                  <td>
                    <p *ngIf="newItem.itemUsage; then usageBlock; else rValueBlock"></p>
                    <ng-template #usageBlock>{{newItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                    <ng-template #rValueBlock>
                      <span *ngIf="newItem.item && newItem.item.rValue">
                        {{newItem.item.rValue.rValue_Desc}}
                      </span>
                    </ng-template>
                  </td>
                  <td>
                    <span *ngIf="newItem.changeOrderItem_IsCustomItem">
                      {{newItem.changeOrderItem_Note}}
                    </span>
                    <span *ngIf="newItem.item">
                      <span *ngIf="newItem.item.item_Part">{{newItem.item.item_Part}},</span>
                      {{newItem.item.item_Name}}
                    </span>
                  </td>
                  <td>
                    {{newItem.changeOrderItem_SqrFtgAdjustment | number: '1.2' }}
                  </td>
                  <td>
                    <div *ngIf="area.area_IsOption; else defaultAccessories">
                      <div *ngIf="showLinePricing">
                        ${{newItem.optionBid | number: '1.2' }}
                      </div>
                    </div>
                    <ng-template #defaultAccessories>
                      {{newItem.accessories.length}}
                    </ng-template>
                  </td>
                  <td *ngIf="showLinePricing">
                    <span>${{newItem.changeOrderItem_TotalCost | number: '1.2' }}</span>
                  </td>
                  <td>
                    <div *ngIf="!this.readOnly">
                      <button class="btn btn-bidit-navigate" (click)="revertChangeOrder(newItem.changeOrderItem_ID)" title="Revert Change" i18n>Undo Change</button>
                      <button class="ml-3 btn btn-bidit-edit" (click)="openAreaDialog(area, newItem.changeOrderItem_ID)" title="Edit"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </tbody>
            <tfoot>
              <tr *ngIf="showLinePricing" class="no-border">
                <td colspan="5"></td>
                <td><h7 i18n>Change:</h7></td>
                <td><h7>${{area.totalCost | number: '1.2-2'}}</h7></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>

      </div>
      <div class="col-sm-3">
        <div>
          <button *ngIf="canApprove && !this.changeOrder.changeOrder_Approved" (click)="approveChangeOrder()" class="btn btn-bidit-submit btn-md" i18n>Approve Change Order</button>
        </div>

        <div *ngIf="showCostBreakdown" class="cost-breakdown-pnl">
          <h5 align="center" i18n>COST BREAKDOWN</h5>
          <table class="table table-bidit">
            <tbody>
              <tr>
                <td i18n>Material Cost:</td>
                <td>${{changeOrder.materialCost | number: '1.2'}} ({{100 * changeOrder.materialCost / changeOrder.totalCost | number: '1.2-2'}}%)</td>
              </tr>
              <tr>
                <td i18n>Labor Cost:</td>
                <td>${{changeOrder.laborCost | number: '1.2'}} ({{100 * changeOrder.laborCost / changeOrder.totalCost | number: '1.2-2'}}%)</td>
              </tr>
              <tr>
                <td i18n>Other Cost:</td>
                <td>${{changeOrder.otherCost | number: '1.2'}} ({{100 * changeOrder.otherCost / changeOrder.totalCost | number: '1.2-2'}}%)</td>
              </tr>
              <tr>
                <td i18n>Total Cost:</td>
                <td>${{changeOrder.totalCost | number: '1.2'}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="estimate-pnl">
          <h5 align="center" i18n>ESTIMATE</h5>
          <table class="table table-bidit">
            <tbody>
              <tr *ngIf="showLinePricing">
                <td i18n>Total Cost:</td>
                <td>${{changeOrder.totalCost | number: '1.2'}}</td>
              </tr>
              <tr *ngIf="showMargins">
                <td i18n>Gross Margin:</td>
                <td>
                  <div *ngIf="showMarginEdit==false">
                    <a *ngIf="!this.readOnly" class="float-left" href="javascript:void(0);" (click)="editMargin()" i18n>Edit</a>

                    <span class="float-right">{{changeOrder.changeOrder_GrossMargin | number: '1.0-4'}}%</span>
                  </div>
                  <div *ngIf="showMarginEdit" class="form-group" id="showMargin">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-danger form-control" (click)="updateQuoteMargin()" i18n>Update</button>
                    </div>
                    <input name="changeOrder_GrossMargin" type="number" id="changeOrder_GrossMargin" class="form-control"
                           [(ngModel)]="changeOrder.changeOrder_GrossMargin" #changeOrder_GrossMargin="ngModel" />
                  </div>
                </td>
              </tr>
              <tr *ngIf="showLinePricing">
                <td i18n>Bid Subtotal:</td>
                <td>
                  <div *ngIf="showBidAmountEdit==false">
                    <a *ngIf="!this.readOnly" href="javascript:void(0);" (click)="editBid()" i18n>Edit</a>
                    <span class="float-right">${{changeOrder.changeOrder_BidAmount | number: '1.2-2'}}</span>
                  </div>

                  <div *ngIf="showBidAmountEdit" class="input-group input-group-sm" id="show">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-danger form-control" name="editAmount" value="editAmount" (click)="updateBidAmount()" i18n>Update</button>
                    </div>
                    <input name="changeOrder_BidAmount" id="changeOrder_BidAmount" type="text" class="form-control"
                           style="text-align:right;"
                           [(ngModel)]="changeOrder.changeOrder_BidAmount" #changeOrder_BidAmount="ngModel">
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <button *ngIf="!this.readOnly" (click)="openTaxDialog()" class="btn btn-bidit-navigate btn-md" i18n>Edit Tax</button>
                  <label *ngIf="this.readOnly" i18n>Tax Amount:</label>
                </td>
                <td>${{changeOrder.netTax_Total | number: '1.2-2'}}</td>
              </tr>
              <tr>
                <td i18n>Bid Amount:</td>
                <td>${{changeOrderTotalBidAmount | number: '1.2-2'}}</td>
              </tr>
              <tr *ngIf="showMargins">
                <td i18n>Margin Dollars:</td>
                <td>${{changeOrderMarginAmount | number: '1.2-2'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
    </div>

    <div class="row" align="center">
      <div class="col-12">
        <button (click)="printQuote()" *ngIf="!isRequesting && allowPrint" class="btn btn-bidit-action mr-1" i18n>Print</button>
        <button (click)="openEmailDialog()" *ngIf="!isRequesting && allowPrint" class="btn btn-bidit-action" i18n>Send</button>
        <button (click)="acknowledgeChangeOrder(2)" *ngIf="!isRequesting && this.changeOrderAcknowlegement?.acknowledgementStatusDesc == 'Pending' || this.changeOrderAcknowlegement?.acknowledgementStatusDesc == 'Accepted'" class="ml-1 btn btn-bidit-action" onclick="this.blur();" i18n>Reject</button>

        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
    </div>
    <div class="row">
      <div class=" col-sm-9">
        <button (click)="returnToList()" class="btn btn-bidit-submit float-right" i18n>Back</button>
      </div>
    </div>
  </div>
</div>
